import { ICellRendererParams } from '@ag-grid-community/core';

import { AUX_ICONS } from '@shared/components/icon/icon';

export const extendableOptionsDropdownRenderer = (params: ICellRendererParams) => {
  const container = document.createElement('div');

  container.classList.add(
    'flex',
    'justify-between',
    'h-full',
    'w-full',
    'items-center',
    'pl-[10px]',
    'pr-[6px]'
  );

  const eDiv = document.createElement('div');

  eDiv.classList.add('truncate');
  eDiv.innerText = params.value;
  container.appendChild(eDiv);

  const icon = document.createElement('div');

  icon.innerHTML = AUX_ICONS.IconCaretDownFilled;
  icon.classList.add('text-[--text]', 'cursor-pointer');
  icon.firstElementChild!.classList.add('w-[16px]', 'h-[16px]');
  icon.addEventListener('click', () => {
    setTimeout(() => {
      params.api.startEditingCell({
        colKey: params.column!.getColId(),
        rowIndex: params.node.rowIndex!,
      });
    }, 0);
  });
  container.appendChild(icon);

  return container;
};
